module.exports = __webpack_public_path__ + "static/media/logo.96585ed6.svg";